import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const xray = {
    jpath: ['spectra', 'xray'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default xray;
//# sourceMappingURL=xray.js.map